import { createAction, props } from '@ngrx/store';
import {
  CaseRecordTypeEnum,
  CaseState,
  CaseStatusesEnum,
} from '../../interfaces/interfaces';
import { ICasePayment } from '../../components/case-card/interfaces/case-card-interfaces';

export const setPaymentInformations = createAction(
  '[Case] SET Case Payment Informations Case',
  props<{
    caseDate: Date;
    caseNo: number;
    caseStatus: CaseStatusesEnum;
    caseType: any;
    createdAt: Date;
    id: number;
    paymentInformations: ICasePayment[];
    recordType: CaseRecordTypeEnum;
    uid: string;
  }>()
);

export const deletePaymentInformation = createAction(
  '[Case] Delete Case Payment Informations Case',
  props<{
    paymentId: number;
  }>()
);

export const setPaymentInformationSuccess = (
  state: CaseState,
  payload: {
    caseDate: Date;
    caseNo: number;
    caseStatus: CaseStatusesEnum;
    caseType: any;
    createdAt: Date;
    id: number;
    paymentInformations: ICasePayment[];
    recordType: CaseRecordTypeEnum;
    uid: string;
  }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      id: payload?.id,
      caseType: payload?.caseType,
      caseNo: payload?.caseNo,
      createdAt: payload?.createdAt ?? null,
      caseStatus: payload?.caseStatus,
      recordType: payload?.recordType ?? null,
      uid: payload?.uid ?? null,
      caseDate: payload?.caseDate,
      paymentInformations:
        payload?.paymentInformations?.map((p: any) => {
          return {
            id: p?.id ?? null,
            paymentType: p?.paymentType
              ? {
                  label: p?.paymentType?.valueObject?.name?.value,
                  value: p?.paymentType?.valueObject?.id?.value,
                }
              : null,
            exchangeType: p?.exchangeType
              ? {
                  label: p?.exchangeType?.valueObject?.name?.value,
                  value: p?.exchangeType?.valueObject?.id?.value,
                }
              : null,
            staff: p?.staff
              ? {
                  label: p?.staff?.firstName + ' ' + p?.staff?.lastName,
                  value: p?.staff.id,
                }
              : null,
            institution: p?.institution
              ? {
                  label: p?.institution?.signboard,
                  value: p?.institution.id,
                }
              : null,
            provisionNo: p?.provisionNo ?? null,
            paymentDate: p?.paymentDate ?? null,
            total: p?.total ?? null,
            totalTL: p?.totalTL ?? null,
            rateOfExchange: p?.rateOfExchange ?? null,

            uuid: p?.uuid ?? null,
            payed: p?.payed ?? null,
            sipayStatus: p?.sipayStatus ?? null,
            sipaySmsSended: p?.sipaySmsSended ?? null
          };
        }) ?? [],
    },
    loading: false,
    error: null,
  };
};

export const deletePaymentInformationSuccess = (
  state: CaseState,
  payload: {
    paymentId: number;
  }
) => {
  const newPayments = state.case.paymentInformations
    .filter((e) => e.id !== payload.paymentId)
    .map((elem) => elem);

  return {
    ...state,
    case: {
      ...state.case,
      paymentInformations: newPayments,
    },
    loading: false,
    error: null,
  };
};
